export default "__VITE_ASSET__BMn$0DrA__"